module.exports = __webpack_public_path__ + "static/bbis-careers-3-71935f6bd2b2b356fd81e1e7de6b9676.jpeg";